import type { Resource } from "~lib/resourceHelpers.ts";

export interface ResourceCacheEntry {
  resource: Resource;
  displayName: string;
}

export function createResourceMap(
  resources: Resource[] | undefined,
): Map<string, ResourceCacheEntry> {
  const map = new Map<string, ResourceCacheEntry>();
  if (!resources) return map;

  for (const resource of resources) {
    if (resource.id && resource.displayName) {
      map.set(resource.id, {
        resource,
        displayName: resource.displayName,
      });
    }
  }
  return map;
}

export function findResourceInMap(
  resourceMap: Map<string, ResourceCacheEntry>,
  id?: string | null,
): Resource | undefined {
  if (!id) return undefined;
  return resourceMap.get(id)?.resource;
}

export function getResourceNameFromMap(
  resourceMap: Map<string, ResourceCacheEntry>,
  id?: string | null,
): string {
  if (!id) return "";
  const entry = resourceMap.get(id);
  return entry?.displayName || id;
}
